import useCustomization from 'app/hooks/useCustomization';

export default function useLiveChatBotAvatar() {
  const customization = useCustomization();

  return customization?.bot_avatar;
}
